/*
 * Collection page "Add To Cart" -> AJAX add + cart popup
 * ------------------------------------------------------
 * The Marmeto collection grid renders plain <form action="/cart/add"> forms
 * (inside an undefined <product-form> element), so the browser posts the form
 * and jumps to the /cart page. This catches those submits, adds the item with
 * the theme's own cart code (theme.Cart) and opens the cart popup instead,
 * exactly like the product page does. Fires 'theme:cart::added' like the theme.
 *
 * Forms the theme already handles (Shella .js-product-button-add-to-cart) never
 * reach here, because the theme cancels those clicks before a submit happens.
 * If theme.Cart is not ready, the form submits normally as before.
 */
(function () {
  'use strict';

  if (window.__collectionAjaxAdd) return;
  window.__collectionAjaxAdd = true;

  var ADD_RE = /\/cart\/add\/?$/;

  function isAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    try {
      return ADD_RE.test(new URL(action, location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.classList.toggle('is-loading', on);
    var spinner = btn.querySelector('.loading-overlay__spinner');
    var label = btn.querySelector('.btn-cart');
    if (spinner) spinner.classList.toggle('hidden', !on);
    if (label) label.style.visibility = on ? 'hidden' : '';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !isAddForm(form)) return;

    var cart = window.theme && window.theme.Cart;
    var $ = window.jQueryTheme;
    if (!cart || !$ || typeof cart.addItem !== 'function' || typeof cart.serializeForm !== 'function') return; // fall back to normal submit

    e.preventDefault();

    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn && btn.disabled) return;
    setLoading(btn, true);

    var item = cart.serializeForm($(form));

    cart.addItem(item)
      .then(function (response) {
        if (!response) throw new Error('No response');

        function done() {
          document.dispatchEvent(new CustomEvent('theme:cart::added', {
            detail: { button: btn, product: form.closest('[data-js-product]') || form, data: item }
          }));
          return cart.updateCart().then(function () {
            cart.showPopup();
          });
        }

        if (response.ok) return done();

        if (response.status === 422) {
          // e.g. "You can't add more of this item to the cart" (stock limit)
          return response.json().then(function (err) {
            alert(err.description || err.message || 'This item could not be added to the cart.');
            return cart.updateData().then(function () {
              return cart.updateCart();
            });
          });
        }

        throw new Error('Add to cart failed: ' + response.status);
      })
      .catch(function () {
        // Something unexpected: let the normal form post handle it.
        setLoading(btn, false);
        HTMLFormElement.prototype.submit.call(form);
      })
      .then(function () {
        setLoading(btn, false);
      });
  });
})();
